import { ERROR_MESSAGES } from '@constants/index';
import dayjs from 'dayjs';

const today=new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

interface PNCDetail {
    pnc: number;
    start: number;
    end: number;
};

interface PNCResult {
    pnc: number;
    startDate: string;
    endDate: string;
};

export const getOngoingPNCDetails = (deliveryDate: string, visitDate:any): PNCResult[] => {
  const pncDetails: PNCDetail[] = [
      { pnc: 1, start: 0, end: 1 },
      { pnc: 2, start: 2, end: 5 },
      { pnc: 3, start: 6, end: 12 },
      { pnc: 4, start: 13, end: 19 },
      { pnc: 5, start: 20, end: 26 },
      { pnc: 6, start: 27, end: 40 },
      { pnc: 7, start: 41, end: 44 }
  ];

  const delivery = dayjs(deliveryDate);
  const currentDate = dayjs(visitDate).isValid() ? dayjs(visitDate) : dayjs();

  const results = pncDetails.map(pnc => {
      const startDate = delivery.add(pnc.start, 'day').format('YYYY-MM-DD');
      const endDate = delivery.add(pnc.end, 'day').format('YYYY-MM-DD');
      return {
          pnc: pnc.pnc,
          startDate,
          endDate
      };
  });

  const ongoingPNCs = results.filter(pnc => {
      const start = dayjs(pnc.startDate);
      const end = dayjs(pnc.endDate);
      return (currentDate.isAfter(start) || currentDate.isSame(start, 'day')) && (currentDate.isBefore(end) || currentDate.isSame(end, 'day')); 
  });
  return ongoingPNCs;
};

export const firstPncObj: any = {
  placeOfDelivery: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
};

export const pncObj: any = {
  hbLevel: {
    isError: false,
    message: '',
    isDisable: false,
    value: 1,
  },
  numIFATabsGiven: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId:'',
    serviceId:'',
  },
  numCalciumTabsGiven: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId:'',
    serviceId:'',
  },
  anyDangerSignsForMother: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
  },
};

export const ChildPncObj: any = {
  exclusiveBreastFeeding: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',
  },
  babyTestedForHiv: { 
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',    
  },
  dangerSigns: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',
  },
  referredToHigherFacilityForDangerSigns: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',
  },
  VisibleBirthDefect: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',
  },
  referredToHigherFacilityForBirthDefect: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',
  },
  methodOfTreatment: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
    reportId: '',
    serviceId: '',
  },
  referredToNacpReferralFacility:{
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  }
};

export const childPncData = {
  exclusiveBreastFeeding: {
  '#type': 'select',
  '#title': 'Exclusive Breast Feeding Continuing?',
  '#webform_key': 'exclusiveBreastFeeding',
  '#required': true,
  '#options': []
},
babyTestedForHiv: {
  '#type': 'select',
  '#title': 'whether baby tested for HIV?',
  '#webform_key': 'babyTestedForHiv',
  '#required': true,
  '#options': []
},
dangerSigns: {
  '#type': 'select',
  '#title': 'Indicate Danger Signs(If any) present in Baby',
  '#webform_key': 'dangerSigns',
  '#required': true,
  '#multiDropdown': true,
},
referredToHigherFacilityForDangerSigns: {
  '#type': 'select',
  '#title': 'Treated/Referred to a Higher Facility',
  '#webform_key': 'referredToHigherFacilityForDangerSigns',
  "#isDisabled":true,
  '#options': [],
},
VisibleBirthDefect: {
  '#type': 'select',
  '#title': 'Any visible birth defect seen?',
  '#webform_key': 'VisibleBirthDefect',
  '#required': true,
  '#multiDropdown': true,
},
referredToHigherFacilityForBirthDefect: {
  '#type': 'select',
  '#title': 'Treated/Referred to a Higher Facility',
  '#webform_key': 'referredToHigherFacilityForBirthDefect',
  "#isDisabled":true,
  '#options': [],
},
methodOfTreatment: {
  '#type': 'select',
  '#title': 'Method of Treatment(If Treatment done)',
  '#webform_key': 'methodOfTreatment',
  "#isDisabled":true,
  '#options': []
},
referredToNacpReferralFacility: {
  '#type': 'select',
  '#title': 'Referred to NACP referral facility',
  '#webform_key': 'referredToNacpReferralFacility',
  '#options': [],
  '#required': false,
  '#isDisabled': true,
}
};

export const pncServiceData = {
  // hbLevel: {
  //   '#type': 'textfield',
  //   '#title': 'Hb (g/dL)',
  //   '#webform_key': 'hbLevel',
  //   '#required': false,
  // },
  hbLevel: {
    '#type': 'slider',
    '#title': 'Hb (g/dL)',
    '#webform_key': 'hbLevel',
    '#required': false,
    '#min':1,
    '#max':18,
    '#default':1,
    '#smallStep': 0.1,
    '#largeStep': 1,
  },
  numIFATabsGiven: {
    '#type': 'textfield',
    '#title': 'Number of IFA tabs given',
    '#webform_key': 'numIFATabsGiven',
    '#required': false,
  },
  numCalciumTabsGiven: {
    '#type': 'textfield',
    '#title': 'Number of Calcium + Vit D3 tabs given',
    '#webform_key': 'numCalciumTabsGiven',
    '#required': true,
  },
  anyDangerSignsForMother: {
      '#type': 'select',
      '#title': 'Any danger Signs present for Mother?',
      '#webform_key': 'anyDangerSignsForMother',
      '#required': true,
      '#multiDropdown': true,
  },
};

export const pncFirstVisitData = {
  placeOfDelivery: {
    '#type': 'select',
    '#title': 'Place of Delivery',
    '#webform_key': 'placeOfDelivery',
    '#required': true,
    '#options': []
  },
};

export const visitFormData:any={
  dateOfVisit: {
    '#type': 'date',
    '#title': 'Date of Visit',
    '#webform_key': 'dateOfVisit',
    '#required': true,
    '#minDate': dayjs().subtract(29, 'day'),
    '#maxDate': today,
    '#individualDates': []
  },
};

export const PNC_COMMON_CONSTANTS = {
  MODAL_UNSAVED_TITLE: 'You have unsaved changes. Are you sure you want to leave without saving?',
  CLOSE_MODAL_TITLE: 'Do you want to close the form?',
  FACILITY_DETAILS: 'Facility Details',
  ADD_DETAILS: 'Add Details',
  TITLE: 'Add Details/PNC Mother',
  PNC: 'PNC',
  ABORTION_CARE:"Abortion Care",
  ANY_DANGER_SIGN_FOR_MOTHER: 'any_danger_sign_present_for_mother',
  HB: "hb_gm",
  MODAL_TITLE: "Do you want to close the form?",
  CHANGES_MODAL_TITLE: "You have unsaved changes. Are you sure you want to leave without saving?",
  SUCCESS_MSG: (isEdit: boolean) => {
    return isEdit ? "PNC Service has been successfully updated" : "PNC Service has been successfully created";
  },
  TRANSIT: 'transit',
  INSTITUTIONAL: 'institutional',
  HOME: 'Home',
  PNC_MOTHER: 'pnc_mother',
  SYSTEM_CLOSED:'System Closed',
  DELIVERY_OUTSIDE_RCH:"Delivery outside JANANI",
  ABORTION_OUTSIDE_RCH:"Abortion outside JANANI",
  DELIVERY_DETAILS:"Delivery Details",
  AUTO_CLOSURE_PREGNANCY: 'auto_close_pregnancy',
  ON_GOING: 'on going',
  ABORTION: 'abortion',
  ABORTION_DETAILS:"beneficiary_abortion_details",
  CLOSE_PREGNANCY: 'close_pregnancy',
  PREVIOUS_PREGNANCY: 'previous_pregnancy',
};

export const PNC_CHILD_COMMON_CONSTANTS = {
  MODAL_UNSAVED_TITLE: 'You have unsaved changes. Are you sure you want to leave without saving?',
  CLOSE_MODAL_TITLE: 'Do you want to close the form?',
  FACILITY_DETAILS: 'Facility Details',
  ADD_DETAILS: 'Add Details',
  TITLE: 'Add Details/PNC Child',
  PNC: 'PNC CHILD',
  MODAL_TITLE: "Do you want to close the form?",
  CHANGES_MODAL_TITLE: "You have unsaved changes. Are you sure you want to leave without saving?",
  SUCCESS_MSG: (isEdit: boolean) => {
    return isEdit ? "Child PNC Service has been successfully updated" : "Child PNC Service has been successfully created";
  },
  // TRANSIT: 'transit',
  // INSTITUTIONAL: 'institutional',
  // HOME: 'Home',
  TREATED: 'Treated',
  REFERRED: 'Referred',
};

export const PNC_ERROR_MESSAGES = {
  FACILITY_TYPE:'',
  FIELD_REQUIRED: (fieldName: any) => `${fieldName} cannot be blank.`,
  TABLET_MESSAGE: (taken:any, limit:any, difference:any) => {
    const tabletWord = difference === 1 ? 'tablet' : 'tablets';
    return `You have already taken ${taken} tablets and the limit is ${limit}. Please select less than or equal to ${difference} ${tabletWord}.`;
  },
  TABLET_LIMIT_MESSAGE: (tabletType:any, limit:any) => `${tabletType} cannot be more than ${limit}.`,
  GET_API_ERROR_MESSAGE: (apiName: string) => `Error in retrieving data from the ${apiName} API`,
  POST_API_ERROR_MESSAGE: (apiName: string) => `Error in creating ${apiName}.`,
  MAX_TABLET_EXCEEDS: 'Maximum allowed quantity is exhausted',
  errorInRecentVisitDate: 'Error in getting recent visit dates.'
};

export const PNC_CHILD_ERROR_MESSAGES = {
  ERROR_MESSAGE: 'This field cannot be kept blank. Select a valid option.',
  EXCLUSIVE_BREAST_FEEDING: 'Exclusive Breast Feeding Continuing cannot be blank.',
  BABY_TESTED_FOR_HIV: 'Baby tested for HIV cannot be blank.',
  DANGER_SIGNS: 'Indicate Danger Signs(If any) present in Baby cannot be blank.',
  REFERRED_TO_HIGHER_FACILITY: 'This field cannot be kept blank. Select a valid option treated or referred from options.',
  VISIBLE_BIRTH_DEFECT: 'Any visible birth defect seen cannot be blank.',
  METHOD_OF_TREATMENT: 'Method of Treatment cannot be kept empty. Select an applicable option. ',
}
export const PNC_API_DETAILS = {
  BACKDATED_ENTRY: 'back dated data',
  DELIVERY_OUTCOME: 'delivery outcome',
  TABLET_COUNT: 'tablet count',
  PLACE_OF_DELIVERY: 'place of delivery',
  CONTRACEPTION_METHOD: 'contraception method',
  SERVICE_REPORT: 'service report',
  CONTRACEPTION_TYPE: 'contraception type',
  CREATE_PNC: 'mother PNC',
  CREATE_CHILD_PNC: 'child PNC',
  SERVICE_SUB_CATEGORY: 'service sub category',
  NON_PREGNANT_SUB_CATEGORY: 'non pregnant service sub category',
  SERVICE_SUB_CATEGORY_LIST: 'service sub category list',
  METHOD_OF_TREATMENT: 'method of treatment',
  HBNC_SERVICE_LIST: 'HBNC service list',
  SERVICE_SUBCATEGORY: 'service subcategory',
  CHILD_TREATMENT: 'child treatment Info',
};



export const PNC_FIELDS_NAME = {
  FACILITY_TYPE: 'Facility Type',
  FACILITY_NAME: 'Facility Name',
  HPR_NAME: 'Health Provider Name',
  ASHA_NAME: 'Asha Name',
  DATE_OF_DELIVERY: 'Date of Delivery',
  DATE_OF_DISCHARGE:'Date of Discharge from Health Facility After Delivery',
  TIME_OF_DISCHARGE:'Time of Discharge from Health Facility After Delivery',
  DATE_OF_VISIT: 'Date of Visit',
  VISIT_NUMBER:'Visit Number',
  PLACE_OF_DELIVERY: 'Place of Delivery',
  DELIVERY_DONE: 'Is Delivery Done',
  CONTRACEPTIONS: 'Contraceptions',
  CONTRACEPTION_TYPE: 'Contraception Type',
  HB_LEVEL: 'Hb Level',
  IFA_TABS: 'Number of IFA tabs given',
  CALCIUM_V3_TABS: 'Number of Calcium + Vit D3 tabs given',
  DANGER_SIGNS_FOR_MOTHER: 'Any Danger Signs present for Mother',
  EXCLUSIVE_BREAD_FEEDING: 'Exclusive Breast Feeding Continuing',
  DANGER_SIGN_FOR_CHILD: 'Danger Signs(If any) present in Baby',
  BIRTH_DEFECT: 'Any visible birth defect seen',
  METHOD_OF_TREATMENT: 'Method of Treatment',
  BABY_TESTED_FOR_HIV: 'Baby tested for HIV',
  TREATED_TO_A_HIGHER_FACILITY: 'Treated/Referred to a Higher Facility',  
  REFERRED_TO_HIGHER_FACILITY: 'Treated/Referred to a Higher Facility',
};

export const PNC_CHILD_FIELDS_NAME = {
    FACILITY_TYPE: 'Facility Type',
    FACILITY_NAME: 'Facility Name',
    HPR_NAME: 'Health Provider Name',
    ASHA_NAME: 'Asha Name',
    DATE_OF_DELIVERY: 'Date of Delivery',
    DATE_OF_VISIT: 'Date of Visit',
    VISIT_NUMBER:'Visit Number',
    PLACE_OF_DELIVERY: 'Place of Delivery',
    EXCLUSIVE_BREAST_FEEDING_CONTINUING: 'Whether Exclusive Breast Feeding Continuing?',
    BABY_TESTED_FOR_HIV: 'whether baby tested for HIV?',
    INDICATE_DANGER_SIGNS: 'Indicate Danger Signs(If any) present in Baby',
    TREATED_TO_A_HIGHER_FACILITY: 'Treated to a Higher facility',
    ANY_VISIBLE_BIRTH_DEFECT_SEEN: 'Any visible birth defect seen?',
    METHOD_OF_TREATMENT: 'Method of Treatment(If Treatment done)',
  };

  export const PNC_CHILD_KEY_NAMES = {
    REFERRED_TO_HIGHER_FACILITY_FOR_BIRTH_DEFECT: "referredToHigherFacilityForBirthDefect",
  }

export const hbOptions = [
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
];

export const TABLET_FIELD_LIMITS = {
  numIFATabsGiven: 400,
  numCalciumTabsGiven: 360,
};

export const PNC_NAVIGATION = {
  PNC_MOTHER: '/beneficiaries/pnc/create-pnc',
}